import { PropTypes as MobxPropTypes, observer } from 'mobx-react';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { DropdownItem } from 'reactstrap';

import globalTranslations from '../../../i18n/globalTranslations';
import Country from '../../../models/Country';
import { modelOf } from '../../../prop-types';
import DropdownSelect from '../../common/DropdownSelect';
import LocaleFlagIcon from '../LocaleFlagIcon';
import RegionalSettingsOptionLabel from '../RegionalSettingsOptionLabel';

const DEFAULT_LARGE_MENU_LENGTH = 16;

const RegionalSettingsDeliveryCountryDropdown = ({
  country,
  countries,
  onSelect,
  showLabelText,
  toggleClassName,
  toggleNav,
  disabled,
  positionFixed,
  menuContainer,
  menuClassName,
}) => {
  const countryCode = country.iso_code_2.toUpperCase();
  const selectedCountryLabel = (
    <span className="RegionalSettingsDeliveryCountryDropdown__selected-item">
      <LocaleFlagIcon locale={country.iso_code_2.toLowerCase()} decorative />
      <span className="RegionalSettingsDeliveryCountryDropdown__selected-item-text">
        {countryCode}
      </span>
    </span>
  );

  return (
    <DropdownSelect
      className="RegionalSettingsDeliveryCountryDropdown"
      label={
        showLabelText ? (
          <FormattedMessage
            {...globalTranslations.deliveryCountryLabel}
            values={{
              country: selectedCountryLabel,
            }}
          />
        ) : (
          selectedCountryLabel
        )
      }
      isLarge={countries.length > DEFAULT_LARGE_MENU_LENGTH}
      focusSelectedItemOnKeyboardOpen
      focusToggleOnClose
      toggleClassName={toggleClassName}
      toggleNav={toggleNav}
      disabled={disabled}
      positionFixed={positionFixed}
      menuContainer={menuContainer}
      menuClassName={menuClassName}
    >
      {countries.map((countryOption) => {
        const isActive = country.id === countryOption.id;
        const optionCode = countryOption.iso_code_2.toUpperCase();

        return (
          <DropdownItem
            key={countryOption.id}
            className="RegionalSettingsDeliveryCountryDropdown__item"
            onClick={() => onSelect(countryOption)}
            active={isActive}
            aria-current={isActive ? 'true' : undefined}
          >
            <RegionalSettingsOptionLabel
              lead={optionCode}
              trail={countryOption.name}
            />
          </DropdownItem>
        );
      })}
    </DropdownSelect>
  );
};

RegionalSettingsDeliveryCountryDropdown.propTypes = {
  country: modelOf(Country).isRequired,
  countries: MobxPropTypes.observableArrayOf(modelOf(Country)).isRequired,
  onSelect: PropTypes.func.isRequired,
  showLabelText: PropTypes.bool,
  toggleClassName: PropTypes.string,
  toggleNav: PropTypes.bool,
  disabled: PropTypes.bool,
  positionFixed: PropTypes.bool,
  menuContainer: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
    PropTypes.func,
  ]),
  menuClassName: PropTypes.string,
};

RegionalSettingsDeliveryCountryDropdown.defaultProps = {
  showLabelText: true,
  toggleClassName: undefined,
  toggleNav: false,
  disabled: false,
  positionFixed: false,
  menuContainer: undefined,
  menuClassName: undefined,
};

export default observer(RegionalSettingsDeliveryCountryDropdown);
